import { toSafeAppPath } from "@shared/authRouting";

export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

export const getLoginPath = (returnTo?: string) => {
  const safeReturnTo = toSafeAppPath(returnTo);
  return safeReturnTo ? `/login?returnTo=${encodeURIComponent(safeReturnTo)}` : "/login";
};